export const ExamStatusEnum = {
  "-1": "未交卷",
  0: "考试中",
  1: "考试中",
  2: "已结束"
};
//考试通过分数线
export const ExamPassedScore = 80;
